<template>
  <Row :gutter="12">
    <Col span="18">
      <el-slider v-model="price" range :marks="marks" :min="0" :max="11000" :show-tooltip="false" @change="calStep"></el-slider>
    </Col>
    <Col span="6">
      <span class="c-price-txt" :style="{ paddingLeft: '12px' }">{{ formatMarks }}</span>
    </Col>
    <Col span="24">
      <div class="c-price-short c-price-txt">
        <span>快捷设置:</span>
        <a href="javascript:;" @click="$emit('on-short', [2000, 4000])">2000元-4000元</a>
        <a href="javascript:;" @click="$emit('on-short', [4000, 6000])">4000元-6000元</a>
        <a href="javascript:;" @click="$emit('on-short', [6000, 8000])">6000元-8000元</a>
        <a href="javascript:;" @click="$emit('on-short', [8000, 11000])">8000元以上</a>
      </div>
    </Col>
  </Row>
</template>
<script>
export default {
  name: 'rangPrice',
  props: {
    value: {
      type: Array
    },
    closeMarks: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    price: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    formatMarks() {
      let price = ''
      const [min, max] = this.price
      if (min === 0 && max === 11000) price = '不限'
      else if (min === 0) price = `${max}元以内`
      else if (max === 11000) price = `${min}元以上`
      else price = `${min}元-${max}元`
      return price
    },
    marks() {
      return {
        0: '0',
        500: '',
        1000: '',
        1500: '',
        2000: '2000元',
        2500: '',
        3000: '',
        3500: '',
        4000: '',
        5000: '5000元',
        6000: '',
        7000: '',
        8000: '',
        9000: '',
        10000: '1万元',
        11000: ''
      }
    }
  },
  methods: {
    calStep(e) {
      if (this.closeMarks) {
        const marks = Object.keys(this.marks)
        const [start, end] = e
        // 找到最接近的元素进行跳转
        const startClosest = marks.sort((a, b) => Math.abs(start - a) - Math.abs(start - b))[0]
        const endClosest = marks.sort((a, b) => Math.abs(end - a) - Math.abs(end - b))[0]
        this.price = [startClosest, endClosest]
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-price-short {
  padding-top: 20px;
}

.c-price-txt {
  display: inline-block;
  font-size: 14px;
  line-height: 36px;

  a,
  span {
    margin-right: 24px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
